
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swap",
      function () {
        return require("private-next-pages/swap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/swap"])
      });
    }
  